// class QuickViewDrawer extends MenuDrawer {
//   constructor() {
//     super();

//     this.setClasses({
//       open: 'quick-view--open',
//       opening: 'quick-view--opening',
//       closing: 'quick-view--closing'
//     });

//     this.addEventListener('close', () => {
//       const drawerContent = this.querySelector('.quick-view__content');
//       drawerContent.innerHTML = '';
//       drawerContent.classList.remove('hide-cover');

//       document.dispatchEvent(new CustomEvent('quickview:close'));
//     });
//   }
// }
// customElements.define('quick-view-drawer', QuickViewDrawer);

// class QuickViewButton extends MenuDrawer {
//   constructor() {
//     super();

//     this.addEventListener('click', () => {
//       const wrapper = this.closest('.card-wrapper');
//       const drawer = wrapper.querySelector('quick-view-drawer');
//       if (drawer) {
//         drawer.querySelector('summary').click();

//         document.dispatchEvent(new CustomEvent('quickview:open', {
//           detail: {
//             productUrl: this.dataset.productUrl
//           }
//         }));
//       }
//       else if (this.dataset.productUrl) {
//         window.location.href = this.dataset.productUrl;
//       }
//     });
//   }
// }
// customElements.define('quick-view-button', QuickViewButton);

// class QuickView extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
//   }

//   handleIntersection(entries, _observer) {
//     if (!entries[0].isIntersecting) return;

//     const selector = '.quick-view__content';
//     const drawerContent = this.querySelector(selector);
//     const productUrl = this.dataset.productUrl.split('?')[0];
//     const sectionUrl = `${productUrl}?view=modal`;

//     fetch(sectionUrl)
//       .then(response => response.text())
//       .then(responseText => {
//         setTimeout(() => {
//           const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//           const productElement = responseHTML.querySelector(selector);
//           this.setInnerHTML(drawerContent, productElement.innerHTML);

//           if (window.Shopify && Shopify.PaymentButton) {
//             Shopify.PaymentButton.init();
//           }
//         }, 200);

//         setTimeout(() => {
//           drawerContent.classList.add('hide-cover');

//           document.dispatchEvent(new CustomEvent('quickview:loaded', {
//             detail: {
//               productUrl: this.dataset.productUrl
//             }
//           }));
//         }, 500);
//       })
//       .catch(e => {
//         console.error(e);
//       });
//   }

//   setInnerHTML(element, html) {
//     element.innerHTML = html;

//     // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//     element.querySelectorAll('script').forEach(oldScriptTag => {
//       const newScriptTag = document.createElement('script');
//       Array.from(oldScriptTag.attributes).forEach(attribute => {
//         newScriptTag.setAttribute(attribute.name, attribute.value)
//       });
//       newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//       oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//     });
//   }
// }
// customElements.define('quick-view', QuickView);

class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    
    console.log("Product URL:", productUrl);
    console.log("Product Template:", this.dataset.productTemplate);
    console.log("Current Page:", document.body.className);

    let sectionUrl = `${productUrl}?view=modal`;

    // Only use new modal on product page
    // if (document.body.classList.contains('template-product')) {
    //   sectionUrl = `${productUrl}?view=new-modal`;
    //   console.log("Product Page → Using NEW modal:", sectionUrl);
    // } else {
    //   console.log("Other Page → Using OLD modal:", sectionUrl);
    // }

    if (
        document.body.classList.contains('template-product') ||
        document.body.classList.contains('template-collection')
      ) {
      sectionUrl = `${productUrl}?view=new-modal`;
      console.log("Using NEW modal:", sectionUrl);
    } else {
      sectionUrl = `${productUrl}?view=modal`;
      console.log("Using OLD modal:", sectionUrl);
    }

    fetch(sectionUrl)
    .then(response => response.text())
    .then(responseText => {
      setTimeout(() => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector(selector);
        this.setInnerHTML(drawerContent, productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }, 200);

      setTimeout(() => {
        drawerContent.classList.add('hide-cover');

        document.dispatchEvent(new CustomEvent('quickview:loaded', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }, 500);
    })
    .catch(e => {
      console.error(e);
    });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);

document.addEventListener('click', function(e) {
  const button = e.target.closest('.quick-view__content .collapsible-content__button, .quick-view__content details summary');
  if (!button) return;

  const currentDetails = button.closest('details');
  const modal = button.closest('.quick-view__content');
  if (!modal) return;

  const allDetails = modal.querySelectorAll('.product__accordion details, .collapsible-content details');

  allDetails.forEach(details => {
    if (details !== currentDetails && details.hasAttribute('open')) {
      details.removeAttribute('open');
    }
  });
});